<template>
  <div class="elevation-0">
    <v-card elevation="0" class="mb-0">
      <v-row>
        <v-col class="mt-1 text-justify">
          <form-transfer-wallet
            v-show="getCloseSetTransWallet"
          ></form-transfer-wallet>
          <form-confirm-transfer-wallet
            v-show="getConfirmTransWallet"
          ></form-confirm-transfer-wallet>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import FormTransferWallet from "./FormTransferWalletEnterprise";
import FormConfirmTransferWallet from "./FormConfirmTransferWalletEnterprise";
import { mapHelper } from "../../../../store/helper";
export default {
  name: "SetTransferWallet",
  components: { FormConfirmTransferWallet, FormTransferWallet },
  computed: {
    ...mapHelper
  }
};
</script>

<style scoped></style>
